import {
  ApplNow,
  IReqPatentRightsPage,
  PatentSearchNameOptions,
  PatentSearchNoOptions,
} from 'src/types/api/patentRightsApiTypes';
import { changeNumToApplClass } from './PatentResult';

interface Iprops {
  reqParams: IReqPatentRightsPage;
}
/**
 * 專利搜尋條件
 */
const PatentSearchTip: React.FC<Iprops> = ({ reqParams }) => {
  return (
    <div>
      {reqParams.applyClass && (
        <>
          專利類型：
          {changeNumToApplClass(reqParams.applyClass)}
          <span>｜</span>
          <br />
        </>
      )}
      {reqParams.isEffective && (
        <>
          權利是否存續：
          {ApplNow[reqParams.isEffective as keyof typeof ApplNow]}
          <span>｜</span>
          <br />
        </>
      )}
      {reqParams.searchNo && reqParams.searchNo.value && (
        <>
          {
            PatentSearchNoOptions.filter((item) => item.value === reqParams.searchNo?.keyWord)[0]
              .label
          }
          ：{reqParams.searchNo.value}
          <span>｜</span>
          <br />
        </>
      )}
      {reqParams.publishBDate && (
        <>
          公告日期：
          {reqParams.publishBDate}
          {reqParams.publishEDate && '~' + reqParams.publishEDate}
          <span>｜</span>
          <br />
        </>
      )}
      {reqParams.patentName && (
        <>
          專利中英文名稱：
          {reqParams.patentName}
          <span>｜</span>
          <br />
        </>
      )}
      {reqParams.searchName && reqParams.searchName.value && (
        <>
          {
            PatentSearchNameOptions.filter(
              (item) => item.value === reqParams.searchName?.keyWord,
            )[0].label
          }
          ：{reqParams.searchName.value}
          <span>｜</span>
          <br />
        </>
      )}
      {reqParams.chargeExpirBDate && (
        <>
          年費有效日期：
          {reqParams.chargeExpirBDate}
          {reqParams.chargeExpirEDate && '~' + reqParams.chargeExpirEDate}
        </>
      )}
    </div>
  );
};

export default PatentSearchTip;
